import { Container, Tabs, Title, Text, Box } from '@mantine/core';
import { IconChartBar, IconReceipt, IconUser } from '@tabler/icons-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { SubscriptionOverview } from './SubscriptionOverview';
import { PackageQuota } from './PackageQuota';
import { BillingHistory } from './BillingHistory';

interface PaymentInfo {
  order: number;
  created_at?: string;
  end_at?: string;
  used_tokens: number;
  max_tokens: number;
  used_questions: number;
  max_questions: number;
  type?: string;
  canceled_at?: string;
}

interface AccountCenterProps {
  paymentInfo?: PaymentInfo;
}

export const AccountCenter = ({ paymentInfo }: AccountCenterProps) => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState<string | null>('overview');

  return (
    <Container size="lg" py="xl">
      <Box mb="xl">
        <Title order={1} mb="xs">
          {t('account.title')}
        </Title>
        <Text c="dimmed" size="md">
          {t('account.subtitle')}
        </Text>
      </Box>

      <Tabs value={activeTab} onChange={setActiveTab} variant="outline" radius="md" keepMounted={false}>
        <Tabs.List mb="xl">
          <Tabs.Tab value="overview" leftSection={<IconUser size={18} />} style={{ padding: '12px 20px' }}>
            {t('account.tabs.overview')}
          </Tabs.Tab>
          <Tabs.Tab value="quota" leftSection={<IconChartBar size={18} />} style={{ padding: '12px 20px' }}>
            {t('account.tabs.quota')}
          </Tabs.Tab>
          <Tabs.Tab value="history" leftSection={<IconReceipt size={18} />} style={{ padding: '12px 20px' }}>
            {t('account.tabs.history')}
          </Tabs.Tab>
        </Tabs.List>

        <Tabs.Panel value="overview">
          <SubscriptionOverview paymentInfo={paymentInfo} />
        </Tabs.Panel>

        <Tabs.Panel value="quota">
          <PackageQuota paymentInfo={paymentInfo} />
        </Tabs.Panel>

        <Tabs.Panel value="history">
          <BillingHistory />
        </Tabs.Panel>
      </Tabs>
    </Container>
  );
};
